export enum BeforeSubmitPopupEnum {
  HINGE_REQUIRED = 'HINGE_REQUIRED',
  OVERRIDE_DIMENSIONS = 'OVERRIDE_DIMENSIONS',
  ZERO_PRICING = 'ZERO_PRICING',
}
